import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { RootState, useAppDispatch, useAppSelector } from '../store';
import { UserSettings } from '../Types';
import { connectorService } from '../Services/connectorService';
import { setListReloadType } from '../Store/features/environment/environmentSlice';
import { PaginationListType } from '../Types/PaginationParams';
import useModal from '../components/Modal/useModal';
import { getBreakpoint } from '../utils/breakpoint';

const usePromptFunctions = () => {
    const navigate = useNavigate();
    const userSettings = useAppSelector((state: RootState) => state.userSettings as UserSettings);
    const i18n = useAppSelector((state: RootState) => state.i18n.i18n);
    const dispatch = useAppDispatch();
    const windowWidth = useAppSelector((state: RootState) => state.environment.windowWidth);
    const modal = useModal();
    const deletePromptfunction = useCallback(
        (identifier: string) => {
            if (!userSettings.isLoggedIn) return;

            connectorService.deleteConnector(identifier).then(() => {
                dispatch(setListReloadType(PaginationListType.Connectors));
            });
        },
        [userSettings.isLoggedIn, dispatch],
    );

    const handleOpenConfirmDialog = useCallback(
        (apiKeyIdentifier: string) => {
            modal.deleteConfirm({
                title: i18n.translate({ id: 'promptFunctionDelete.title', sourceName: 'PromptFunctions' }),
                content: i18n.translate({ id: 'promptFunctionDelete.text', sourceName: 'PromptFunctions' }),
                onConfirm: () => deletePromptfunction(apiKeyIdentifier),
            });
        },
        [modal, deletePromptfunction, i18n],
    );

    const PromptFunctionsActions = useMemo(
        () => ({
            deletePromptfunction,
            handleOpenConfirmDialog,
        }),
        [deletePromptfunction, handleOpenConfirmDialog],
    );

    const handleNavigate = useCallback(
        (path: string) => {
            navigate(path);
        },
        [navigate],
    );

    return {
        PromptFunctionsActions,
        handleNavigate,
        i18n,
        windowWidth,
        getBreakpoint,
    };
};

export default usePromptFunctions;
